module.exports = __webpack_public_path__ + "static/img/sc_yy@2x.e429263.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sc_yy@2x.png
// module id = EBYr
// module chunks = 1